export const useShowApiError = (message: string = 'Not found', statusCode: number = 404, fatal: boolean = false) => {
  const errorObject = createError({
    statusCode,
    message,
    fatal,
  })

  return { errorObject }
}
